var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeCarnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-13 0 120 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.16,17.06H17.84c-6.29,0-11.39,5.1-11.39,11.39v36.09c0,6.29,5.1,11.39,11.39,11.39h64.33c6.29,0,11.39-5.1,11.39-11.39V28.46c0-6.29-5.1-11.39-11.39-11.39ZM85.96,28.46v36.09c0,2.1-1.7,3.8-3.8,3.8H17.84c-2.1,0-3.8-1.7-3.8-3.8V28.46c0-2.1,1.7-3.8,3.8-3.8h64.33c2.1,0,3.8,1.7,3.8,3.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.34,32.23c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.77-3.78,3.77h-25.93c-2.09,0-3.77-1.69-3.77-3.77s1.69-3.78,3.77-3.78h25.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.99,44.43c2.09,0,3.78,1.69,3.78,3.78s-1.69,3.77-3.78,3.77h-14.58c-2.09,0-3.77-1.69-3.77-3.77s1.69-3.78,3.77-3.78h14.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeCarnet);
export default __webpack_public_path__ + "static/media/acae_carnet.012d8c9d.svg";
export { ForwardRef as ReactComponent };